export default "assets/images/bg-key-items-c942a0f7.jpg";